"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getModelService(
        $slug: String
        $salesModelId: Int
        $zipcode: String
        $includeDimensions: Boolean!
        $includePrice: Boolean!
        $includeFloorplan: Boolean!
        $includeThumbnail: Boolean!
        $includeDollhouse: Boolean!
        $includeMatterport: Boolean!
        $includeGallery: Boolean!
        $includeTestimonials: Boolean!
        $includeFeatures: Boolean!
    ) {
        model(slug: $slug, salesModelId: $salesModelId, zipCode: $zipcode) {
            id
            salesModelId
            sourceId
            modelNumber
            description
            slug
            name
            beds @include(if: $includeDimensions)
            baths @include(if: $includeDimensions)
            squareFeet @include(if: $includeDimensions)
            length @include(if: $includeDimensions)
            width @include(if: $includeDimensions)
            price @include(if: $includePrice)
            floorplan @include(if: $includeFloorplan) {
                url
                description
            }
            thumbnail @include(if: $includeThumbnail) {
                url
                description
            }
            dollhouse @include(if: $includeDollhouse) {
                url
                description
            }
            matterport @include(if: $includeMatterport)
            multiSection
            zipCode
            galleryImages @include(if: $includeGallery) {
                url
                description
            }
            testimonials @include(if: $includeTestimonials) {
                edges {
                    node {
                        name
                        content
                    }
                }
            }
            contentfulFeatures @include(if: $includeFeatures) {
                edges {
                    node {
                        name
                        ordinal
                        type
                        description
                        featureTag
                        thumbnail
                        icon
                    }
                }
            }
        }
    }
`;exports.getModel=e;
//# sourceMappingURL=queries.js.map
